﻿var myPlayer,
    playerHTML;

$(document).ready(function () {
    var autoplayPodcast = getUrlParameter('autoplayPodcast');

    if (autoplayPodcast === 'play') {
        addPlayer();
    }
});

/*Add Player*/
function addPlayer(videoId, accountId, playerId, youtubeId) {
    if (youtubeId !== undefined) {
        addYouTubePlayer(videoId, youtubeId);
    }
    else {
        addBrightcovePlayer(videoId, accountId, playerId);
    }
}
/*Add Player*/

function addBrightcovePlayer(videoId, accountId, playerId) {
    $("#" + videoId).css('display', 'none');
    playerHTML = "<video-js id=\"myPlayerID\" data-video-id=\"" + videoId + "\" data-account=\"" + accountId + "\" data-player=\"" + playerId + "\" \ndata-embed=\"default\" width=\"205\" height=\"36\" class=\"video-js\" style=\"width:205px;height:36px\" controls></video-js>";
    document.getElementById("placeHolder-" + videoId).innerHTML = playerHTML;
    var tagScript = document.createElement("script");
    tagScript.src = "https://players.brightcove.net/" + accountId + "/" + playerId + "_default/index.min.js";
    document.body.appendChild(tagScript);
    tagScript.onload = callback;
}

function addYouTubePlayer(videoId, youtubeId) {
    $("#" + videoId).css('display', 'none');
    playerHTML = "<object data='https://www.youtube.com/embed/" + youtubeId + "?autoplay=0' width='205px' height='36px'></object>";
    document.getElementById("placeHolder-" + videoId).innerHTML = playerHTML;
}

function playYouTubeVideo(event) {
    myPlayer.playVideo();
}

function pauseYouTubeVideo() {
    myPlayer.pauseVideo();
}

function stopYouTubeVideo() {
    myPlayer.stopVideo();
}

function callback() {
    myPlayer = bc("myPlayerID");
    myPlayer.on("loadedmetadata", function () { myPlayer.play() });
}

function getUrlParameter(sParam) {
    var sPageURL = parent.window.location.search.substring(1),
        sURLVariables = sPageURL.split('&');

    sURLVariables.forEach(function (item, index) {
        var keyValue = sURLVariables[index].split('=');
        var key = keyValue[0];
        var value = keyValue[1];

        if (key === sParam) {
            return value ? true : decodeURIComponent(value);
        }
    });
};